var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"d-flex align-center"},[_c('Breadcrumbs',{staticClass:"pa-2",attrs:{"head":"Giảng phí"}}),_c('div',{staticClass:"flex-fill"})],1),_c('div',[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }